module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_toMCRichards_LanternExtract_3envelope_c1962.5f6b8a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_toMCRichards_LanternExtract_3envelope_c1962.jpg
// module id = PiuH
// module chunks = 0